!function() {
    "use strict";
    const e = "[data-video-template]",
        t = "is-loading",
        i = "data-video-id",
        // Neue Klasse für das Kontroll-Overlay
        a = "is-paused"; 

    customElements.get("video-background") || customElements.define("video-background", class extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.videoId = this.getAttribute(i),
            this.videoTemplate = this.querySelector(e),
            this.video = null,
            this.videoId && this.renderVideo();
        }

        // Neue Methode: Spielt das Video ab und entfernt das "Pausiert"-Overlay
        playVideoOnClick() {
            if (this.video && this.video.paused) {
                this.video.play().then(() => {
                    this.classList.remove(a); // Entfernt die Pausen-Klasse (z.B. für ein Play-Icon-Overlay)
                }).catch(error => {
                    console.error("Video-Wiedergabe fehlgeschlagen:", error);
                });
            } else if (this.video && !this.video.paused) {
                this.video.pause();
                this.classList.add(a); // Fügt die Pausen-Klasse hinzu
            }
        }

        renderVideo() {
            // IntersectionObserver nur zum Laden des Video-Tags verwenden, nicht zum Abspielen
            this.videoTemplateObserver = new IntersectionObserver(((e, i) => {
                e.forEach((e => {
                    if (e.isIntersecting) {
                        const o = this.videoTemplate.innerHTML;
                        this.innerHTML = o;
                        this.classList.remove(t);
                        this.video = this.querySelector("video");
                        
                        // Das Video wird nun nicht automatisch abgespielt.
                        // Wir fügen den Klick-Listener zum Container hinzu.
                        this.addEventListener("click", this.playVideoOnClick.bind(this));
                        this.classList.add(a); // Startet im Pausiert-Zustand (zum Anzeigen des Play-Icons)

                        // Beobachter, der das Laden des Videos (IntersectionObserver) stoppt.
                        i.unobserve(e.target);
                    }
                }));
            }), {
                root: null,
                rootMargin: "300px",
                threshold: [0, .1, .25, .5, .75, 1]
            }), this.videoTemplateObserver.observe(this);
        }

        // Diese Funktion wird entfernt, da wir nicht mehr automatisch abspielen/pausieren
        // observeVideoPlayToggle() {} 

        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect();
            // Die eventuellen Listener zum automatischen Abspielen wurden entfernt
            // Stattdessen den eigenen Klick-Listener entfernen
            this.removeEventListener("click", this.playVideoOnClick.bind(this));
        }
    })
}();